<template>
	<div class="notice alert" :class="[`notice-${level} alert-${level}`, { 'is-active': isActive }]">
		<div class="notice-title">{{ title }}</div>
		<div class="notice-message pr-3" v-html="this.sanitizeHtml(descriptionDisplay)"></div>
		<i
			class="notice-dismiss material-icons"
			@click="dismiss"
			v-tooltip="$t('Dismiss')">close</i>
	</div>
</template>

<script>
import { urlify, sanitizeHtml } from '@/lib/helper';

export default {
	name: 'AppNotice',
	props: {
		level: {
			type: String,
			default: 'warning',
		},
		title: {
			type: String,
			default: '',
		},
		description: {
			type: String,
			default: '',
		},
		isActive: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		dismiss() {
			this.$emit('dismiss');
		},
		sanitizeHtml,
	},
	computed: {
		descriptionDisplay() {
			return urlify(this.description);
		},
	},
};
</script>
